module.exports = __webpack_public_path__ + "static/media/PATS_7-480w.42bebe51.png";